import React from 'react';
import { IResourceComponentsProps, useShow } from '@refinedev/core';
import {
  Show,
  NumberField,
  TextField,
  ImageField,
  BooleanField,
} from '@refinedev/antd';
import { Typography } from 'antd';

const { Title } = Typography;

export const EarnCategoryShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow();
  const { data, isLoading } = queryResult;

  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>ID</Title>
      <NumberField value={record?.id ?? ''} />
      <Title level={5}>Name</Title>
      <TextField value={record?.name} />
      <Title level={5}>Icon</Title>
      <ImageField style={{ maxWidth: 200 }} value={record?.icon} />
      <Title level={5}>Description</Title>
      <TextField value={record?.description} />
      <Title level={5}>Sort</Title>
      <NumberField value={record?.sort ?? ''} />
      <Title level={5}>Is Active</Title>
      <BooleanField value={record?.isActive} />
    </Show>
  );
};
